import React from 'react';
import { WINDOW_PRESETS } from '../lib/dicom-renderer.js';
import styles from './WindowPanel.module.css';

export default function WindowPanel({ wc, ww, onChange }) {
  return (
    <div className={styles.panel}>
      <div className={styles.row}>
        <label className={styles.label}>WC</label>
        <input
          className={styles.input}
          type="number"
          value={Number.isFinite(wc) ? Math.round(wc) : 0}
          onChange={(e) => onChange?.(Number(e.target.value), ww)}
        />
      </div>
      <div className={styles.row}>
        <label className={styles.label}>WW</label>
        <input
          className={styles.input}
          type="number"
          value={Number.isFinite(ww) ? Math.round(ww) : 1}
          onChange={(e) => onChange?.(wc, Math.max(1, Number(e.target.value)))}
        />
      </div>
      <div className={styles.presets}>
        {WINDOW_PRESETS.map(p => (
          <button key={p.name}
                  className={styles.preset}
                  onClick={() => onChange?.(p.wc, p.ww)}
                  title={`WC ${p.wc} / WW ${p.ww}`}>
            {p.name}
          </button>
        ))}
      </div>
    </div>
  );
}
